import type { EraseStep } from "@amtana/module";
import { moduleApi } from "@amtana/module";

import type { CreateExportInput, Export, ExportFile, ExportList } from "./export.schemas.ts";

/** Every call is scoped to the caller's active organization (ADR-001 §5); `userId` is the author. */
type ForOrganization = { readonly userId: string; readonly organizationId: string };

export interface ExportApi extends EraseStep {
  list(input: ForOrganization): Promise<ExportList>;
  get(input: ForOrganization & { readonly exportId: string }): Promise<Export>;
  create(input: ForOrganization & CreateExportInput): Promise<Export>;
  retry(input: ForOrganization & { readonly exportId: string }): Promise<Export>;
  /** The file itself, once the export has completed. */
  file(input: ForOrganization & { readonly exportId: string }): Promise<ExportFile>;
  /** Operator-only (D053): no transport door. Stamps rows left over from before S1.03. */
  backfillOrganizationId(): Promise<{ readonly assigned: number }>;
}

export const ExportApi = moduleApi<ExportApi>()("export");
